export default __webpack_public_path__ + "static/media/info-modal-info.58ecb87e.svg";